import { isMobileDevice } from "@src/domains/shared/helpers/deviceHelper";
import { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

interface IRouteProps {
  isAuthenticated: boolean;
}

export const PrivateRoute: FC<PropsWithChildren<IRouteProps>> = ({
  isAuthenticated,
  children,
}) => {
  if (isAuthenticated) {
    return children;
  }

  return isMobileDevice() ? (
    <Navigate to="/m/login" />
  ) : (
    <Navigate to="/login" />
  );
};
